import CONSTANTS from './constants';
import BaseHttpHandler from './utilities/baseHttpHandler';

// Gets a set of useful information about the currently authenticated user.
// Response: Company Name, Full Name
async function About() {
    try {
        let instance = await BaseHttpHandler.getInstance();

        const response = await instance.get(
            CONSTANTS.API_CONSTANTS.ENDPOINTS.ACCOUNT_ABOUT,
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );

        return response.data;

    } catch (e) {
        // If the Account/About endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
        console.log(e);
        throw (e);
    }
}

// Changes a user's password
async function changePassword(currentPassword, newPassword, confirmNewPassword) {
    try {
        let instance = await BaseHttpHandler.getInstance();
        const data = {
            currentPassword,
            newPassword,
            confirmNewPassword,
        };

        return await instance.put(
            CONSTANTS.API_CONSTANTS.ENDPOINTS.ACCOUNT_CHANGE_PASSWORD,
            data,
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );

    } catch (e) {
        // If the returns anything other a 200 response okay message we need to know about it and handle it appropriately
        console.log(e);
        if (e.response) {
            throw (e.response.data);
        } else {
            throw (e.message);
        }
    }
}

// Changes a user's password
async function setPassword(password) {
    try {
        let instance = await BaseHttpHandler.getInstance();
        const data = {
            password,
        };

        return await instance.put(
            CONSTANTS.API_CONSTANTS.ENDPOINTS.ACCOUNT_PASSWORD_SET,
            data,
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );

    } catch (e) {
        // If the returns anything other a 200 response okay message we need to know about it and handle it appropriately
        console.log(e);
        if (e.response) {
            throw (e.response.data);
        } else {
            throw (e.message);
        }
    }
}

// Gets password hints
// Response: { maxLength: 128, minLength: 8, minLower: 0, minNumbers: 0, minSpecial: 0, minUpper: 0, recent: 3 }
async function getPasswordHints() {
    try {
        let instance = await BaseHttpHandler.getInstance();

        const response = await instance.get(
            CONSTANTS.API_CONSTANTS.ENDPOINTS.ACCOUNT_PASSWORD_HINTS,
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );
        return response.data;

    } catch (e) {
        // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
        console.log(e);
        throw (e);
    }
}

// Gets account profile
// Response: {"firstname": "sample string 1",  "surname": "sample string 2",  "email": "sample string 3",  "emailVerified": true,  "pendingEmailVerification": true}
async function getAccountProfile() {
    try {
        let instance = await BaseHttpHandler.getInstance();

        const response = await instance.get(
            CONSTANTS.API_CONSTANTS.ENDPOINTS.ACCOUNT_PROFILE,
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );

        return response.data;

    } catch (e) {
        // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
        console.log(e);
        throw (e);
    }
}

// Sets account profile
async function setAccountProfile(firstname, surname, email) {
    try {
        let instance = await BaseHttpHandler.getInstance();
        const data = {
            firstname,
            surname,
            email,
        };

        const response = await instance.put(
            CONSTANTS.API_CONSTANTS.ENDPOINTS.ACCOUNT_PROFILE,
            data,
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );

        return response.data;

    } catch (e) {
        // If the returns anything other a 200 response okay message we need to know about it and handle it appropriately
        console.log(e);
        if (e.response) {
            throw (e.response.data);
        } else {
            throw (e.message);
        }
    }
}

async function resendVerificationEmail() {
    try {
        let instance = await BaseHttpHandler.getInstance();

        return await instance.put(
            CONSTANTS.API_CONSTANTS.ENDPOINTS.RESEND_VERIFICATION_EMAIL,
            [],
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );

    } catch (e) {
        // If the returns anything other a 200 response okay message we need to know about it and handle it appropriately
        console.log(e);
        if (e.response) {
            throw (e.response.data);
        } else {
            throw (e.message);
        }
    }
}

export default {
    About,
    changePassword,
    getPasswordHints,
    setAccountProfile,
    getAccountProfile,
    setPassword,
    resendVerificationEmail,
};
